import tw, { styled } from 'twin.macro';

export const StyledEventsLink = styled.a`
  ${tw`block`}
  ${tw`py-[4px] px-1`}
  ${tw`text-left`}
  ${tw`tracking-normal`}
`;

export const StyledType = styled.p`
  ${tw`mb-[4px]`}
  ${tw`font-inter font-semi-bold`}
  ${tw`text-tag-s text-primary-p1`}
`;

export const StyledText = styled.p`
  ${tw`font-poppins font-semi-bold`}
  ${`text-tag-l text-primary-p1`}
`;

export const StyledLocation = styled.p`
  ${tw`mt-[4px]`}
  ${tw`font-inter font-regular`}
  ${tw`text-body-s text-primary-p1`}
`;
